import {useMemo} from 'react';
import {useStore} from 'zustand';
import contentStudioStore, {FileStatus} from '@/stores/contentStudioStore';

function useShouldPollForUploads(checkSelectedAssets = false) {
  const {selectedAssets, files} = useStore(contentStudioStore);

  return useMemo(() => {
    const hasFilesAt100Percent = Object.values(files).some(
      (file) => file.status !== FileStatus.ERROR && file.progress === 100
    );

    if (checkSelectedAssets) {
      return (
        selectedAssets.some((asset) => asset.isUploading) &&
        hasFilesAt100Percent
      );
    }

    return hasFilesAt100Percent;
  }, [checkSelectedAssets, selectedAssets, files]);
}

export default useShouldPollForUploads;
